import { useEffect, useState } from 'react';
import { useField } from '@unform/core';
import { CheckboxProps as CheckboxBaseProps } from '@material-ui/core/Checkbox';

import CheckboxBase from '../components/inputs/Checkbox';

export interface CheckboxProps
    extends Omit<CheckboxBaseProps, 'name' | 'value'> {
    name: string;
}

export default function Checkbox(props: CheckboxProps) {
    const { name, defaultChecked = false, ...restProps } = props;
    const { fieldName, defaultValue, registerField } = useField(name);
    const [value, setValue] = useState(defaultValue ?? defaultChecked);

    function onChange(
        event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean
    ) {
        setValue(event.target.checked);

        restProps.onChange?.(event, checked);
    }

    useEffect(() => {
        if (fieldName) {
            registerField({
                name: fieldName,
                getValue() {
                    return value;
                },
                setValue(_: unknown, avalue: boolean) {
                    setValue(avalue);
                },
            });
        }
    }, [fieldName, registerField, value]);

    return (
        <CheckboxBase
            {...restProps}
            name={name}
            checked={value}
            onChange={onChange}
        />
    );
}
